export const ONBOARDING_PAGE_TITLE = 'Create Customer Account';

export const ONBOARDING_PAGE_DESCRIPTION =
  'Set up a new customer organization with account, plan, and billing details.';

export const ONBOARDING_TOTAL_STEPS = 6;

export type EnterpriseOnboardingRouteStep =
  | 'add-user'
  | 'verify-otp'
  | 'add-organization'
  | 'add-plan'
  | 'order-summary'
  | 'payment-capture';

export enum EnterpriseOnboardingProgress {
  None = 0,
  AwaitingOtp = 1,
  OtpVerified = 2,
  OrganizationCreated = 3,
  PlanSelected = 4,
  SubscriptionCreated = 5,
}

export const ENTERPRISE_ONBOARDING_ROUTE_PROGRESS: Record<
  EnterpriseOnboardingRouteStep,
  EnterpriseOnboardingProgress
> = {
  'add-user': EnterpriseOnboardingProgress.None,
  'verify-otp': EnterpriseOnboardingProgress.AwaitingOtp,
  'add-organization': EnterpriseOnboardingProgress.OtpVerified,
  'add-plan': EnterpriseOnboardingProgress.OrganizationCreated,
  'order-summary': EnterpriseOnboardingProgress.PlanSelected,
  'payment-capture': EnterpriseOnboardingProgress.SubscriptionCreated,
};

export const ENTERPRISE_ONBOARDING_FALLBACK_ROUTE: Record<
  EnterpriseOnboardingProgress,
  EnterpriseOnboardingRouteStep
> = {
  [EnterpriseOnboardingProgress.None]: 'add-user',
  [EnterpriseOnboardingProgress.AwaitingOtp]: 'verify-otp',
  [EnterpriseOnboardingProgress.OtpVerified]: 'add-organization',
  [EnterpriseOnboardingProgress.OrganizationCreated]: 'add-plan',
  [EnterpriseOnboardingProgress.PlanSelected]: 'order-summary',
  [EnterpriseOnboardingProgress.SubscriptionCreated]: 'payment-capture',
};
